import { Theme, useTheme } from "@mui/material";

export function useThemeType() {
  const theme: Theme = useTheme();
  return theme.palette.mode;
}
